import Font from '@maxpreps/shared/styles/font';
import React from 'react';
import styled from 'styled-components';
import THEME from '../../../styles/colors';
import StyledText from '../../../ui/Text/StyledText';
import Anchor from '../../Anchor/Anchor';
import SiteNavDropdown from '../SiteNavDropdown';
import SportSubLinksList from './SportSubLinksList';

const StyledSportLinkDualDropdown = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`;

const StyledDualDropdownTop = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 8px 20px 16px 20px;
  white-space: nowrap;
`;

interface IDualSportDropdownProps {
  leftItems: any[];
  rightItems: any[];
  allSportsLink: string;
}

const DualSportDropdown: React.FC<IDualSportDropdownProps> = ({
  leftItems,
  rightItems,
  allSportsLink
}) => (
  <SiteNavDropdown>
    <StyledDualDropdownTop>
      <StyledText
        className={Font.f16_bold_tall}
        $color={THEME.text.secondary}
        $letterSpacing="1.15px"
      >
        POPULAR SPORTS
      </StyledText>
      <Anchor
        href={allSportsLink}
        className={Font.f14_tall}
        $color={THEME.brand.maxpreps}
        $marginLeft="24px"
      >
        All Sports
      </Anchor>
    </StyledDualDropdownTop>
    <StyledSportLinkDualDropdown>
      <SportSubLinksList subItems={leftItems} header="Boys" $hasRightBorder />
      <SportSubLinksList subItems={rightItems} header="Girls" />
    </StyledSportLinkDualDropdown>
  </SiteNavDropdown>
);

export default DualSportDropdown;
